import { gql } from '../__generated__';

export const GET_GUIDES_REPLACED_BY = gql(/* GraphQL */ `
  query GetGuidesReplacedBy($id: UUID!) {
    guidesReplacedBy(id: $id) {
      id
      docId
      docName
      docTitle
    }
  }
`);
